import { render, staticRenderFns } from "./BundleDiscountPillWithTitle.vue?vue&type=template&id=19dd1715&scoped=true&"
import script from "./BundleDiscountPillWithTitle.vue?vue&type=script&lang=ts&"
export * from "./BundleDiscountPillWithTitle.vue?vue&type=script&lang=ts&"
import style0 from "./BundleDiscountPillWithTitle.vue?vue&type=style&index=0&id=19dd1715&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd1715",
  null
  
)

export default component.exports